const EXPERIENCE_START_YEAR = 2019;

const plusOnRightLanguages = new Set(["ar", "ja", "zh"]);

const getBaseLanguage = (language: string): string => {
  return (language || "en").toLowerCase().split("-")[0];
};

export const getExperienceYearsFrom = (startYear = EXPERIENCE_START_YEAR): number => {
  const currentYear = new Date().getFullYear();
  return Math.max(0, currentYear - startYear);
};

export const formatExperienceYearsWithPlus = (
  years: number,
  language: string
): string => {
  const baseLanguage = getBaseLanguage(language);
  if (plusOnRightLanguages.has(baseLanguage)) {
    return `${years}+`;
  }
  return `+${years}`;
};

export const getLocalizedExperienceYears = (
  language: string,
  startYear = EXPERIENCE_START_YEAR
): string => {
  const years = getExperienceYearsFrom(startYear);
  return formatExperienceYearsWithPlus(years, language);
};
